module.exports = __webpack_public_path__ + "static/media/1005955.dd8a1827.jpg";